import { create } from 'zustand';

interface RequestStateMap {
  [key: string]: boolean;
}

interface RequestStore {
  loadingStates: RequestStateMap;
  
  setLoading: (key: string, isLoading: boolean) => void;
  isLoading: (key: string) => boolean;
  clearLoading: (key?: string) => void;
}

export const useRequestStore = create<RequestStore>((set, get) => ({
  loadingStates: {},

  setLoading: (key: string, isLoading: boolean) => {
    set((state) => ({
      loadingStates: {
        ...state.loadingStates,
        [key]: isLoading,
      },
    }));
  },

  isLoading: (key: string) => {
    return get().loadingStates[key] ?? false;
  },

  clearLoading: (key?: string) => {
    if (!key) {
      set({ loadingStates: {} });
    } else {
      set((state) => {
        const newStates = { ...state.loadingStates };
        delete newStates[key];
        return { loadingStates: newStates };
      });
    }
  },
}));
